// extracted by css-extract-rspack-plugin
export default {"root":"FileListGalleryItem_root__JRwoL","thumbnail":"FileListGalleryItem_thumbnail__i-DxJ","itemText":"FileListGalleryItem_itemText__Trwgk"};